import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgBezichtigen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85E3F9"
      fillRule="evenodd"
      d="M6 22s6.27-8 14-8 14 8 14 8-6.27 8-14 8-14-8-14-8"
      clipRule="evenodd"
    />
    <path
      fill="#00C5F2"
      d="M20 26a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M21.945 19.09A3.5 3.5 0 0 0 20 18.5v-1a4.5 4.5 0 1 1-4.5 4.5h1a3.5 3.5 0 1 0 5.445-2.91M19.51 11.23V6h1v5.23zM11.347 14.054l-3.7-3.7.707-.708 3.7 3.7zM27.947 13.346l3.7-3.7.707.707-3.7 3.7zM6.114 23.972a25 25 0 0 1 2.275-2.418l.682.732a24 24 0 0 0-1.896 1.977 28.9 28.9 0 0 0 7.45 5.37l-.45.894a29.9 29.9 0 0 1-8.034-5.889l-.311-.32z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgBezichtigen);

export default ForwardRef;
